import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'


export default {
	name: 'rejectreasonmaster',
	components: {
		Paginate,
		Pagination,
		Loader
	},
	props: [],
	data() {
		return {
			WarehouseErr: '',
			// totalRows:0,
			ClientErr: '',
			totalPage: 0,
			totalRows:0,
			currentPage: 1,
			pageLimit:10,

			// currentPage: 0,
			addRejectReasonmodal: false,
			detailRejectReasonmodal: false,
			listRejectReasonData: [],
			listRejectReasonDetailsData: [],
			listforviewRejectReasonData: [],
			listWarehouseAddReason: [],
			clientid: '',
			resultCount: 0,
			// pageno: 0,
			// totalPage: 0,
			Reasonaction: '',
			rejectreason: '',
			srrejectreasonid: '',
			status: '',
			Statusaction: '',
			addmodalShow: false,
			rejectID: '',
			loginUserEmail: '',
			showSelectClient: '',
			showSelectWarehouse: '',
			purchasingManager: '',
			isInwardUserForPO: '',
			listWarehouseData: '',
			resultCountDetail: 0,
			warehouse: '',
			client: '',
			clientListData: [],
			addclientid: '',
			listWarehouseAll: [],
			addWarehouseid: '',
			WarehouseErr: '',
			isLoading: false,
		}
	},
	computed: {},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)

		this.pageno = 0;
		this.isLoading = false;
		//this.getRejectReasonMasterList();

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.loginUserEmail = userdetail.email;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.loginUserEmail = userdetail.email;
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break;
		}

	},
	methods: {

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseAll = JSON.parse(plaintextwarehouse);
		// 		if (this.listWarehouseAddReason.length == 0) {
		// 			this.listWarehouseAddReason = this.listWarehouseAll;
		// 		}

		// 	} else {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listWarehouseAll = result.data.data;
		// 			if (this.listWarehouseAddReason.length == 0) {
		// 				this.listWarehouseAddReason = result.data.data;
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },
		// getWarehouseListAddReason() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		clientid: this.addclientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listWarehouseAddReason = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD hh:mm:ss');
		},
		addmodal(rejectrreasonid) {
			this.Statusaction = "add"
			this.addmodalShow = true
			this.rejectID = rejectrreasonid;
		},
		closeaddmodalShow() {
			this.addmodalShow = false
		},
		//open new pop up for saving the rto
		addNewRejectReason() {
			this.Reasonaction = 'add',
				this.addRejectReasonmodal = true,
				this.$validator.reset();
			this.errors.clear();
		},

		//to close add (new) form
		closeNewRejectReason() {
			this.addRejectReasonmodal = false
		},

		closeRejectReasonmodal() {
			this.addRejectReasonmodal = false;
			this.rejectreason = '';
			document.getElementById("rejectreason").value = "";
			this.addWarehouseid = '';
			this.addclientid = '';
			this.listWarehouseAddReason = [];
			this.getWarehouseList();

		},

		closedetailRejectReasonmodal() {
			this.detailRejectReasonmodal = false;
		},
		resetSearchForm() {
			this.srrejectreasonid = '';
			this.status = '';
			this.rejectreason = '';
			this.getRejectReasonMasterList();
		},
		//to get Client list
		// getClientList() {
		// 	this.resultCount = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.clientListData = JSON.parse(plaintextclient);
		// 	} else {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.clientListData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },
		// Add new reject reason
		generateNewReason() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.rejectreason == '' || (localStorage.getItem("selectedWarehouse") == "" && localStorage.getItem("selectedClient") == "")) {
				this.$alertify.error(this.$t('rejectreason.table.enterAllValues'));
				return false;
			} else {
				if (this.user_type == 'client_user') {
					this.input = {
						'reasontext': this.rejectreason.trim(),
						'createdby': this.loginUserEmail,
						'warehouseid': localStorage.getItem("selectedWarehouse"),
						'clientid': localStorage.getItem("selectedClient")
					}
				} else if (this.user_type == 'warehouse_user') {
					this.input = {
						'reasontext': this.rejectreason.trim(),
						'createdby': this.loginUserEmail,
						'warehouseid': localStorage.getItem("selectedWarehouse"),
						'clientid': localStorage.getItem("selectedClient")
					}
				} else {
					this.input = {
						'reasontext': this.rejectreason.trim(),
						'createdby': this.loginUserEmail,
						'warehouseid': localStorage.getItem("selectedWarehouse"),
						'clientid': localStorage.getItem("selectedClient"),
					}
				}

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'AddRejectReason',
						'data': this.input,
						headers: {
							'Authorization': myStr
						}
					})
					.then((response) => {
						if (response.data.errorCode == 0) {
							this.$alertify.success(this.$t('rejectreason.reasonAdded'))
							this.addRejectReasonmodal = false;
							this.rejectreason = '';
							document.getElementById("rejectreason").value = '';
							this.addWarehouseid = '';
							this.addclientid = '';
							this.rejectreason = '';
							this.getRejectReasonMasterList();
						} else {
							this.$alertify.error(response.data.msg)
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})

			}

		},

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.listWarehouseData = []
		// 		this.warehouse = '';
		// 		this.getWarehouseList();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}
		// 	if (this.clientid) {
		// 		if (this.warehouseid == '') {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// 	this.resultCount = 0
		// 	this.totalRows=0
		// 	this.listRejectReasonData = []
		// 	this.totalPage = 0
		// },

		// clientSelectedAdd() {
		// 	this.getWarehouseListAddReason();
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid == '') {
		// 			this.getClientList();
		// 			//this.getRejectReasonMasterList();
		// 		}
		// 	}
		// 	this.resultCount = 0
		// 	this.totalRows=0
		// 	this.listRejectReasonData = []
		// 	this.totalPage = 0
		// },

		viewRejectReasonDetail(id) {
			this.detailRejectReasonmodal = true;
			this.rejectreasonid = id;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.resultCountDetail = 0;
			this.input = ({
				'srrejectreasonid': this.rejectreasonid,
				'warehouseid': localStorage.getItem("selectedWarehouse"),
				'clientid': localStorage.getItem("selectedClient")
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetrejectreasonmasterDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listforviewRejectReasonData = result.data.data
					let totalRows = result.data.count
					this.resultCountDetail = result.data.count
					if (totalRows == 0) {
						this.totalPage = 0
					} else if (totalRows < 10) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(totalRows / 10)
					}

				}, error => {
					console.error(error)
				})
		},
		// deletes target record
		removeRow: function(rejectID) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.rejectreasonid = rejectID;
			//console.log(this.rejectreasonid);
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteRejectReasonDetails',
					'data': {
						"srrejectreasonid": this.rejectreasonid,
						"warehouseid": localStorage.getItem("selectedWarehouse"),
						"clientid": localStorage.getItem("selectedClient")
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listRejectReasonData.splice(this.rejectreasonid, 1);
					this.$alertify.success(this.$t('rejectreason.reasonDeleted'))
					this.addmodalShow = false
					this.getRejectReasonMasterList()
				});
		},
     getRejectReasonMasterSearch(){
			 this.currentPage = 1;
			 this.getRejectReasonMasterList();
		 },
		getRejectReasonMasterList(check) {
			if (localStorage.getItem("selectedClient") == "undefined") {
				if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
					this.$alertify.error(this.$t('common.clientError'))
					return false;
				}

				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				}
			} else {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.resultCount = 0;
				this.isLoading = true;
				this.input = ({
					offset:(this.currentPage - 1) * 10,
					limit: 10,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					clientid: localStorage.getItem("selectedClient")
				})

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getSRRejectReason',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listRejectReasonData = result.data.rows
						this.totalRows = result.data.count
						this.resultCount = result.data.count
						if (this.totalRows == 0) {
							this.totalPage = 0
						} else if (this.totalRows < 10) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / 10)
						}
						this.isLoading = false;

					}, error => {
						console.error(error)
					})
			}

		},

		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getRejectReasonMasterList()
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getRejectReasonMasterList()
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {}).catch(() => {
				console.log('errors exist')
			});
		},
		resetSearchForm() {
			this.isLoading = false;
			this.ClientErr = ''
			this.WarehouseErr = ''
			this.srrejectreasonid = '';
			this.status = '';
			this.rejectreason = '';
			this.resultCount = 0
			this.listRejectReasonData = []
			this.totalRows=0
			this.totalPage = 0
			if (this.user_type == 'warehouse_user') {
				this.client = '';
				this.clientid = ''
			} else if (this.user_type == 'client_user') {
				this.warehouse = '';
				this.warehouseid = ''
			} else {
				this.client = '';
				this.clientid = ''
				this.warehouse = '';
				this.warehouseid = '';
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/sr/rejectreasonmaster/rejectreasonmaster.component.js